(ns frontend.ui.component.lp-portal.report.tearsheet.return-development.controller
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]))

(defn ^{:jsdoc ["@nocollapse"]} point-formatter
  []
  (this-as
   js-data-point
    (let [point (js->clj js-data-point
                         :keywordize-keys
                         true)]
      (str "<strong>TVPI multiple: </strong>"
           (util/->multiple (:y point))))))

(defn tvpi
  [data
   {:keys [y-axis-title
           custom-point-formatter]}]
  (let [data (-> data
                 ;; TODO remove first because value is "N/A" instead of a number or nil
                 ;; TODO data in the XLSX is a table where half of these TVPI values
                 ;; are empty: best solution IMO would be if user could refrain from
                 ;; having tables with no values in XLSX
                 (update :labels #(map util/->date-MMM-yy %))
                 (util/->array-of-tuples :tvpi))
        tick-positions (->> data
                            (map-indexed (fn [idx _]
                                           idx))
                            (vec))
        tick-positions (cond (< (count data) 10)
                             tick-positions
                             (odd? (count tick-positions))
                             (->> tick-positions
                                  (remove odd?)
                                  (vec))
                             :else
                             (->> tick-positions
                                  (remove even?)
                                  (vec)))]
    {:xAxis       {:labels        {:rotation "45"}
                   :type          "category"
                   :tickPositions tick-positions
                   :lineColor     (theme/color [:chart :x-axis :line])
                   :gridLineColor (theme/color [:chart :x-axis :grid-line])}
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}
                   :formatter       (or custom-point-formatter
                                        point-formatter)}
     :yAxis       {:title         {:text (or y-axis-title
                                             "TVPI multiple")}
                   :labels        {:format "{text}x"}
                   :lineColor     (theme/color [:chart :y-axis :line])
                   :gridLineColor (theme/color [:chart :y-axis :grid-line])
                   :softMin       0
                   :softMax       0}
     :colors      (or (util/custom-colors)
                      (util/gradient-colors [:lp-report :chart :bar :gradient-start]
                                            [:lp-report :chart :bar :gradient-end]
                                            1))
     :legend      {:enabled false}
     :plotOptions {:series {:label      {:connectorAllowed false}
                            :pointStart 2021
                            :lineWidth  3}
                   :line   {:marker {:enabled false}}}
     :series      [{:name (or y-axis-title
                              "TVPI multiple")
                    :data data}]}))
